import dom from "../../../../../../dist/jsx-render/dom";
import { app } from "../../../../../Frame/App";
import { ITreeItem } from "../../../../Dynamic/ITreeItem";
import { MeasureEditFactory } from "../../../../../Pages/Measure/MeasureEditFactory";
import { PopupCloseType } from "../../../../PagePopup";
import { DynPopup } from "../../../../../Components/DynPopup";
import { Avatar } from "../../../../../Components/UIElements/Avatar";

export class ListFunctions {

    public static createUserList(element: HTMLElement) {
        let ulElements = element.querySelectorAll("[data-user-list]");

        ulElements.forEach(e => {

            let ulElement = e as HTMLElement;
            let fieldId = ulElement.getAttribute("data-user-list");
            let useAvatars = ulElement.getAttribute("data-use-avatars");

            if (fieldId && fieldId.length > 0) {
                const urlParams = new URLSearchParams(window.location.search);
                const measureIdString = urlParams.get("parentId");
                if (measureIdString) {
                    let measureId = Number(measureIdString);


                    $.ajax({
                        url: app.resolveUrl(`~/api/users/userList/${fieldId}/${measureId}`),
                        method: "GET",
                        success: (response) => {
                            let responseItems = response as any[];
                            if (responseItems) {
                                for (let item of responseItems) {
                                    if (useAvatars && useAvatars == "true") {
                                        ulElement.appendChild(
                                            <div className="user-list-item">
                                                <Avatar id={item.id} name={item.name} hasImage={item.hasImage} type="user" />
                                                <span className="user-name">{item.name}</span>
                                            </div>
                                        );
                                    } else {

                                        ulElement.appendChild(
                                            <div className="user-list-item">
                                                <img className="user-image" src={app.resolveUrl(`~/api/users/getUserPicture/${item.id}`)} />
                                                <span className="user-name">{item.name}</span>
                                            </div>
                                        );
                                    }
                                }
                            }
                        },
                        error: (err) => {
                            console.log(err);
                        }
                    });
                }
            }
        });
    }

    public static createListMeasureLinks(element: HTMLElement) {
        let mlElements = element.querySelectorAll("[data-measure-links]");

        mlElements.forEach(e => {

            let mlElement = e as HTMLElement;
            let fieldId = mlElement.getAttribute("data-measure-links");
            let accessControlUrl = mlElement.getAttribute("data-access-control-url");
            let openUrl = mlElement.getAttribute("data-open-url");

            if (fieldId && fieldId.length > 0) {
                let measureId: number;

                // Determine measure id - check if we are inside a .measure-item
                let measureItemParent = mlElement.closest(".measure-item") as HTMLElement;
                if (measureItemParent) {
                    let dataId = measureItemParent.getAttribute("data-id");

                    if (dataId) {
                        let convertedMeasureId = Number(dataId);
                        if (!isNaN(convertedMeasureId)) measureId = convertedMeasureId;
                    } else {
                        console.log(`measure-links: Inside a measure-item, but data-id cannot be determined: '${dataId}'`);
                    }
                } else {
                    // Use parentId from url
                    const urlParams = new URLSearchParams(window.location.search);
                    const measureIdString = urlParams.get("parentId");
                    if (measureIdString) {
                        measureId = Number(measureIdString);
                    }
                }

                if (measureId && !isNaN(measureId) && measureId != 0) {
                    $.ajax({
                        url: app.resolveUrl(`~/api/measure/getLinkedMeasures/${fieldId}/${measureId}`),
                        method: "GET",
                        success: (response) => {
                            let responseItems = response as ITreeItem[];
                            if (responseItems) {
                                for (let item of responseItems) {
                                    let span = <span className="user-name pointer" data-measure-id={item.id}>{item.text}</span>

                                    let itemElement: HTMLElement = <div className="measure-link-item">
                                        {span}
                                    </div>;

                                    span.addEventListener("click", (event: MouseEvent) => {
                                        let target = event.target as HTMLElement;
                                        let id = target.getAttribute("data-measure-id");

                                        let intId = Number(id);

                                        if (!isNaN(intId) && intId != 0) {
                                            if (accessControlUrl) {
                                                $.ajax({
                                                    url: app.resolveUrl(accessControlUrl + `/${intId}`),
                                                    method: "GET",
                                                    success: (response) => {

                                                        if (response === true) {
                                                            // Open the measure
                                                            ListFunctions.openMeasure(intId, openUrl);
                                                        } else {
                                                            document.body.appendChild(
                                                                <DynPopup showOkButton={true} size="dialog" title={Resources.Common.information}>
                                                                    {Resources.Common.elementCanNotOpen}
                                                                </DynPopup>
                                                            );
                                                        }
                                                    },
                                                    error: (err) => {
                                                        console.log(err);
                                                    }
                                                });

                                            } else {

                                                ListFunctions.openMeasure(intId, openUrl);
                                            }
                                        }
                                    });

                                    mlElement.appendChild(itemElement);
                                }
                            }
                        },
                        error: (err) => {
                            console.log(err);
                        }
                    });
                }
            }
        });
    }

    private static openMeasure = (id: number, openUrl: string = null) => {
        if (openUrl) {
            // open an url and pass the measureId as parentId
            window.location.href = app.resolveUrl(openUrl + id.toString());
        } else {
            MeasureEditFactory.showMeasure({
                measureId: id,
                templateId: 0,
                parentId: 0,
                parentGuid: "",
                fullScreen: true,
                onClose: ((reason: PopupCloseType, id: number) => {
                    if (reason == "save") {
                        document.location = document.location;
                    }
                })
            });
        }
    }

}